import {
	buildQueryString,
	getRoutePath
} from '@sporkbytes/routing';

const entityPathSegment = "client-locations";
function getWithClient(axios, publicId, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [publicId, "with", "client"],
		queryString: buildQueryString(queryStringConfig),
		public: true
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
function getMealMenus(axios, publicMenuProfileId, queryStringConfig) {
	const config = {
		entityPathSegment,
		additionalPathSegments: [publicMenuProfileId, "meal-menus"],
		queryString: buildQueryString(queryStringConfig),
		public: true
	};

	const routePath = getRoutePath(config);

	return axios.get(routePath)
		.then(response => response.data);
}
export {
	getMealMenus,
	getWithClient
};
